module.exports = __webpack_public_path__ + "img/1.b6c2177a.jpeg";